export const config = {
    baseURL:"https://fiscalia.sinoep-ag.com/api/"
}
